import React   from 'react'
import Box     from '@mui/material/Box'
import Loading from 'Components/Loading'
import Title   from 'Components/Title'
import config  from '../../../static/TipoConsulta'
import Back    from 'Components/Back'

import { useHistory } from 'Components/useHistory'
import { usePatient } from 'Components/usePatientContext'
import { ButtonsParticularConvenio } from 'Components/ButtonsParticularConvenio'


const ConvenioParticular = () => {

    const { setPatient, loading } = usePatient()
    const { historyPaths } = useHistory()
    
    historyPaths.clear()
    historyPaths.add('/')
    historyPaths.add('/particular-ou-convenio')

    const resetCpf = () => {
        setPatient( prevState => ({ ...prevState, cpfPaciente: '' }) )
    }

    return <>
        
        <Title title={config.title} />
        <Box >
            <ButtonsParticularConvenio />
            <Back onClick={resetCpf} loading={loading} />
        </Box>
        {loading && <Loading />}
    </>
     
}

export default ConvenioParticular